<div>
  <mat-radio-group [id]="formControlFieldName" [formControlName]="formControlFieldName">
    <mat-radio-button id="{{o.name}}" *ngFor="let o of options" [value]="o"
      matTooltip="{{ o.name === 'Helpdesk' 
      ? 'Operational Property Help Desk' 
      : o.name === 'TOC/FOC' ? 'Train/Freight Operating Company' 
      : '' }}">
      {{o.name}}
    </mat-radio-button>
  </mat-radio-group>
</div>